import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { allMyApplicationsQueryOptions } from "@/features/applications/queries";
import { MyApplicationsPage } from "@/features/applications/my-applications-page";
import { STATIC_LABELS } from "@/lib/nav-registry";

// 全件取得してクライアント側で企業グルーピング / 応募日ソート / 絞り込みを行う。
// URL で保持する UI 状態: 自由検索 (q)・企業選択 (companies)・ステータス (statuses)・応募日の並び順 (order)。
const searchSchema = z.object({
  /** 自由検索（企業名・案件名・提案概要を横断、部分一致）。 */
  q: z.string().optional(),
  /** 企業選択。カンマ区切りの企業名。 */
  companies: z.string().optional(),
  /** ステータス絞り込み。カンマ区切り（事務局の応募管理と同形式）。 */
  statuses: z.string().optional(),
  /** 応募日の並び順。既定は新しい順。 */
  order: z.enum(["asc", "desc"]).default("desc"),
});

// ロールガードは親 layout (`member/route.tsx`) が MEMBER 限定。
export const Route = createFileRoute("/_authenticated/member/my-applications")({
  staticData: { crumb: { label: STATIC_LABELS.memberMyApplications } },
  validateSearch: searchSchema,
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(allMyApplicationsQueryOptions());
  },
  component: MyApplicationsPage,
});
